export default __webpack_public_path__ + "static/media/portfolio5.a82ae9a1.png";